import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Linhas from "../pages/Linhas";
import Viagens from "../pages/Viagens";
import Endereco from "../pages/Endereco";
import Page404 from "../components/Page404";
import Mapa from "../pages/Mapa";
import MapaAllBuss1 from "../pages/MapaAllBussv1";
import Favoritos from "../pages/Favoritos";
import Mais from "../pages/Mais";
import Menu from "../components/Menu";
import Login from "../pages/Login";
import useAuth from "../hooks/useAuth";
import Load from "../components/Load";

export const AppRouter = () => {

  const Private = ({Item}) =>{
    const {signed} = useAuth();
    console.log('signed',signed);
     if(signed===1) {
      return <Load/>
    }else if(signed === 3){
      return <Item/>
    }else{
      return <Login/>
    }
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/mapa" element={<Private Item={Mapa}/>}></Route>
        <Route path="/" element={<Private Item={MapaAllBuss1}/>}></Route>
        <Route path="/linha" element={<Private Item={Linhas}/>}></Route>
        <Route path="/favoritos" element={<Private Item={Favoritos}/>}></Route>
        <Route path="/mais" element={<Private Item={Mais}/>}></Route>
        <Route path="/viagens" element={<Private Item={Viagens}/>}></Route>
        <Route path="/endereco" element={<Private Item={Endereco}/>}></Route>
        <Route path="/page404" element={<Private Item={Page404}/>}></Route>
      </Routes>
    </Router>
  );
};
